import {RouteRecordRaw} from 'vue-router'
import HomeCrm from "@/views/HomeCrm.vue";
import PermessiMenu from "@/components/PermessiMenu.vue";
import FasceDiRicavo from "@/views/BusinessUnit/FasceDiRicavo.vue";
import Configurazioni from "@/views/Configurazioni/Configurazioni.vue";
import ContabilitaAzienda from "@/views/Configurazioni/ContabilitaAzienda.vue";
import BilanciPrevisionaliBu from "@/views/BusinessUnit/BilanciPrevisionaliBu.vue";
import DettaglioBilancioPrevisionale from "@/views/BusinessUnit/BilancioPrevisionale.vue";

const configurazioneRoutes: Array<RouteRecordRaw> = [
    {
        path: '/configurazione/',
        meta: {'app': 'per'},
        components: {
            default: HomeCrm,
            nav: PermessiMenu,
        },

        children: [
            {
                path: '',
                component: Configurazioni,
                name: 'Configurazioni',
                props: true
            },
            {
                path: 'azienda/:id/contabilita/',
                component: ContabilitaAzienda,
                name: 'ContabilitaAzienda',
                props: true
            },
            {
                path: 'business_unit/:id/fasce_ricavo/',
                component: FasceDiRicavo,
                name: 'FasceDiRicavo',
                props: true
            },
            {
                path: 'business_unit/:id/bilancio_previsionale/',
                component: BilanciPrevisionaliBu,
                name: 'BilanciPrevisionaliBu',
                props: true
            },
            {
                path: 'business_unit/:id/bilancio_previsionale/new',
                component: DettaglioBilancioPrevisionale,
                name: 'DettaglioBilancioPrevisionaleNew',
                props: true
            },
            {
                path: 'business_unit/:id/bilancio_previsionale/:bid/',
                component: DettaglioBilancioPrevisionale,
                name: 'DettaglioBilancioPrevisionale',
                props: true
            },

        ],
    },
]

export default configurazioneRoutes
